import { render } from "./newsPage.vue?vue&type=template&id=08beb228&scoped=true"
import script from "./newsPage.vue?vue&type=script&lang=js"
export * from "./newsPage.vue?vue&type=script&lang=js"

import "./newsPage.vue?vue&type=style&index=0&id=08beb228&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08beb228"]])

export default __exports__